export default __webpack_public_path__ + "static/media/image-homepage-hero.da80fc10.jpg";